// extracted by mini-css-extract-plugin
module.exports = {"radioGroup":"SynopsisPropertyForm_radioGroup__ngly9","list":"SynopsisPropertyForm_list__2hvjH"};